export const passwordValidator = (value: string): string | undefined => {
  if (!value || value.trim() === "") {
    return "Password is required";
  }
  if (value.length < 12) {
    return "Password must be at least 12 characters long";
  }
  if (!/[A-Z]/.test(value)) {
    return "Password must contain at least one uppercase letter";
  }
  if (!/[a-z]/.test(value)) {
    return "Password must contain at least one lowercase letter";
  }
  if (!/[0-9]/.test(value)) {
    return "Password must contain at least one number";
  }
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
    return "Password must contain at least one special character";
  }
  return undefined;
};

export const confirmPasswordValidator = (
  password: string,
  confirmPassword: string
): string | undefined => {
  if (textIsFilledValidator(confirmPassword)) {
    return "Password is required";
  }
  if (password !== confirmPassword) {
    return "Passwords do not match";
  }
  const passwordError = passwordValidator(password);
  if (passwordError) {
    return passwordError;
  }
  return undefined;
};

export const textIsFilledValidator = (value: string): string | undefined => {
  if (!value || value.trim() === "") {
    return "This field is required";
  }
  return undefined;
};

export const emailValidator = (value: string): string | undefined => {
  if (!value || value.trim() === "") {
    return "Email is required";
  }
  const emailRegex = /\S+@\S+\.\S+/;
  if (!emailRegex.test(value)) {
    return "Email format is invalid";
  }
  return undefined;
};
